import { useEffect, useState } from "react";
import { CloudDownload, CloudCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { isFileOffline, saveFileOffline, removeFileOffline } from "../lib/offline";

export default function FileOfflineButton({ fileId }) {
  const { t } = useAuth();
  const [off, setOff] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let on = true;
    isFileOffline(fileId).then((v) => { if (on) setOff(v); }).catch(() => {});
    return () => { on = false; };
  }, [fileId]);
  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (off) {
        await removeFileOffline(fileId);
        setOff(false);
        toast.success(t("offline.removed"));
      } else {
        await saveFileOffline(fileId);
        setOff(true);
        toast.success(t("offline.saved"));
      }
    } catch {
      toast.error(t("offline.error"));
    }
    setBusy(false);
  };
  return (
    <button
      onClick={toggle}
      disabled={busy}
      className={`p-1.5 transition-colors ${off ? "text-emerald-400" : "t-secondary hover:text-white"}`}
      data-testid={`file-offline-${fileId}`}
      title={t(off ? "offline.available" : "offline.make_available")}
      aria-label={t(off ? "offline.available" : "offline.make_available")}
      aria-pressed={off}
    >
      {off ? <CloudCheck className="h-4 w-4" /> : <CloudDownload className="h-4 w-4" />}
    </button>
  );
}
